export function parseMediaUrl(
  url: string
): { host: string; bucket: string; filePath: string } | null {
  const pattern: RegExp = /(https?:\/\/[^\/]+)\/([^\/]+)\/(.+)?\?(.+)/
  const match: RegExpExecArray | null = pattern.exec(url)

  // If the URL matches our pattern
  if (match) {
    const host: string = match[1]
    const bucket: string = match[2]
    const filePath: string = match[3]

    /*
      If URL is: 'https://storage.com/test-bucket/6602d663dfe07d72787e11b6/image/test.webp?timestamp=171146198799'
      Expected:
      Host: 'https://storage.com'
      Bucket: 'test-bucket'
      filePath: '6602d663dfe07d72787e11b6/image/test.webp'
    */

    return { host, bucket, filePath }
  } else {
    return null // If the URL does not match our pattern, return null
  }
}
